import { SharedFolder } from '@/graphql/generated/types'

export interface FoldersState {
  folders: FoldersDictionary
  loading?: boolean
  errorMessage?: string
}

export const state: FoldersState = {
  folders: {},
  loading: false
}

export type FoldersDictionary = Record<string, Array<UISharedFolderModel>>

export type UISharedFolderModel = SharedFolder
